var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AgGridWrapper',{ref:"agGrid",attrs:{"title":"Journals (publish)","options":_vm.gridOptions},on:{"selected-rows-entire-row":_vm.rowSelectionChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }